import { useState } from 'react'
import type { Begrepp } from '../types'

function blanda<T>(lista: T[]): T[] {
  const kopia = [...lista]
  for (let i = kopia.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[kopia[i], kopia[j]] = [kopia[j], kopia[i]]
  }
  return kopia
}

export default function Flashcards({ begrepp }: { begrepp: Begrepp[] }) {
  const [kort, setKort] = useState(begrepp)
  const [index, setIndex] = useState(0)
  const [vand, setVand] = useState(false)

  const byt = (nyttIndex: number) => {
    setVand(false)
    setIndex(nyttIndex)
  }

  const aktuellt = kort[index]

  return (
    <div className="flashcard-scen">
      <button
        type="button"
        className={`flashcard${vand ? ' vand' : ''}`}
        onClick={() => setVand((v) => !v)}
        aria-label={vand ? `Förklaring: ${aktuellt.forklaring}` : `Begrepp: ${aktuellt.begrepp}. Tryck för att vända kortet.`}
      >
        <span className="flashcard-inre">
          <span className="flashcard-sida flashcard-fram">{aktuellt.begrepp}</span>
          <span className="flashcard-sida flashcard-bak">{aktuellt.forklaring}</span>
        </span>
      </button>
      <p className="flashcard-hint">Tryck på kortet för att vända det</p>
      <div className="flashcard-kontroller">
        <button
          type="button"
          className="rund-knapp"
          onClick={() => byt(index - 1)}
          disabled={index === 0}
          aria-label="Föregående kort"
        >
          ←
        </button>
        <span className="raknare">
          {index + 1} / {kort.length}
        </span>
        <button
          type="button"
          className="rund-knapp"
          onClick={() => byt(index + 1)}
          disabled={index === kort.length - 1}
          aria-label="Nästa kort"
        >
          →
        </button>
      </div>
      <button
        type="button"
        className="textknapp"
        onClick={() => {
          setKort(blanda(kort))
          byt(0)
        }}
      >
        ⤮ Blanda korten
      </button>
    </div>
  )
}
